import { Component, ViewChild } from "@angular/core";
import { GoogleMap, MapInfoWindow, MapMarker } from "@angular/google-maps";

import { DirectoryItemModel } from "../../models/directory-item.model";

import { MapMarkerModel } from "./map-marker.model";

@Component({
    selector: "pcg-ng-google-map",
    template: require('./google-map.component.html')
})
export class GoogleMapComponent {
    @ViewChild("mapElement", { static: false })
    public mapComponentRef: GoogleMap;

    public location: google.maps.LatLngLiteral = {
        lat: 52.4767,
        lng: -1.8999
    };

    public options: google.maps.MapOptions = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDoubleClickZoom: true,
        scrollwheel: false,
        zoomControl: true,
        minZoom: 5,
        maxZoom: 20
    };

    public zoom = 12;

    public markers: Array<MapMarkerModel> = [];

    @ViewChild(MapInfoWindow, { static: false })
    public infoWindowRef: MapInfoWindow;
    public infoWindowContent: string;

    private _isMapInitialized: boolean = false;

    public initializeMap(): void {
        if (this._isMapInitialized) {
            return;
        }

        navigator.geolocation.getCurrentPosition(position => {
            this.location = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
        }, () => {
        });

        this._isMapInitialized = true;
    }

    public setMapCenter(lat: number, lng: number): void {
        this.location = {
            lat: lat,
            lng: lng
        };
    }

    public updateMapMarkers(pageItems: Array<DirectoryItemModel>): void {
        if (!this._isMapInitialized) {
            this.initializeMap();
        }

        this.markers = [];

        pageItems.forEach((model: DirectoryItemModel) => {
            if (model.hasValidGeoLocation) {
                const infoWindowContent = "<div class='pcg-google-map-info-window'>"
                    + `<span class='pcg-google-map-info-window__title'>${model.name}</span>`
                    + (model.hasValidAddress ? `<br/><span>${model.address}</span>` : "")
                    + (model.hasValidPostcode ? `<br/><span>${model.postcode}</span>` : "")
                    + (model.hasValidPhoneNumber ? `<br/><span><b>Phone:</b> ${model.phone}</span>` : "")
                    + (model.hasValidEmailAddress ? `<br/><span><b>Email:</b> ${model.email}</span>` : "")
                    + (model.hasValidWebsiteAddress ? `<br/><span><a href="${model.website}" target="_blank">${model.website}</a></span>` : "")
                    + "</div>";

                const sameMarker = this.markers.find(obj => obj.latitude === model.latitude && obj.longitude === model.longitude);
                if (sameMarker) {
                    sameMarker.info = sameMarker.info + `<br/>` + infoWindowContent;
                } else {
                    this.markers.push({
                        position: new google.maps.LatLng(model.latitude, model.longitude),
                        label: null,
                        title: model.name,
                        info: infoWindowContent,
                        options: {
                            animation: google.maps.Animation.DROP,
                            draggable: false
                        },
                        latitude: model.latitude,
                        longitude: model.longitude
                    });
                }
            }
        });
    }

    public onMapMarkerClicked(marker: MapMarker, content: string): void {
        this.infoWindowContent = content;
        this.infoWindowRef.open(marker);
    }
}
